import createDocumentStoreClass from './lib/create_document_store_class';
import CustomerProfileConverter from '../immutable_converters/customer_profile_converter';

var CustomerProfileStore = createDocumentStoreClass({
  converter: CustomerProfileConverter,
});

export default CustomerProfileStore;
